// extracted by mini-css-extract-plugin
export default {"drawer":"qUg3CJrhQTwF8MzsQS7q","contentWrapper":"EVJC8M777ERxeserPDeo"};